import type { SVGProps } from 'react'

const SvgInfoToast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="4"
    height="10"
    viewBox="0 0 4 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2 1V6.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="2" cy="8.5" r="0.75" fill="white" />
  </svg>
)

export default SvgInfoToast
